<header class="blog-feature animated fadeIn" [class.with-banner]="!!backgroundImage()"
  [style.background-image]="backgroundImage()" [class.blog-feature--no-before]="!backgroundImage()">

  <span role="button" class="blog-feature__back" (click)="goToBlogs()">
    <i class="fa-solid fa-arrow-left"></i>Back
  </span>

  @if (!isLoading()) {
  <div class="blog-feature__content animated fadeInDown">
    <div class="blog-category">
      <span class="category" [ngStyle]="{'background-color': blogPostDetail()?.category?.color}">
        {{blogPostDetail()?.category?.name}}
      </span>
    </div>
    <h1 class="title" [class.title--text-black]="!backgroundImage()">
      {{blogPostDetail()?.title}}
    </h1>
  </div>
  }

</header>

@defer (when !isLoading()) {

<div class="article">

  <section class="article__content">

    <div class="info">

      <div class="info__detail">

        <div class="d-flex flex-column">
          @if (blogPostDetail()?.author) {
          <span class="info__author">
            {{blogPostDetail()?.author}}
          </span>
          }

          <div class="info__date">
            {{blogPostDetail()?.publishDate}}
          </div>
        </div>

        @if (blogPostDetail()?.titleTags?.length) {
        <div class="d-flex flex-column">
          <h6 class="info__author m-0">
            Tags
          </h6>
          <div class="info__tags">
            @for (tag of blogPostDetail()?.titleTags; track $index) {
            <span>{{tag.name}}</span>
            }
          </div>
        </div>
        }

      </div>

    </div>

    <div class="detail">

      @if (!isLoading() && blogPostDetail()?.image) {
      <img [src]="blogPostDetail()?.image || 'assets/images/product-placeholder.webp'" class="detail__img"
        alt="Image of {{blogPostDetail()?.title}}" (error)="handleImageError($event)" />
      }

      @defer (on viewport) {
      <p [innerHTML]="blogPostDetail()?.content"></p>
      } @placeholder {
      <div></div>
      }

    </div>

  </section>

  <!-- Featured products -->
  @defer (on viewport) {
  @if (blogPostDetail()?.featuredProducts?.length) {
  <hr class="mt-4">
  <section class="animated fadeInDown">
    <div class="row">
      <div class="col-12">
        <div class="title is-center is-full-width mt-5">
          <h2 class="article__title">
            Featured Products
          </h2>
        </div>
      </div>
    </div>
    @if (blogPostDetail()?.addAllButton) {
    <div class="row mb-4 d-flex justify-content-center">
      <button type="button" class="btn btn-primary w-auto h6-semibold head-font" (click)="addAllProducts($event)">
        Add All Products
      </button>
    </div>
    }
    <div class="row">
      <div class="col-md-12">
        <app-carousel [items]="blogPostDetail()?.featuredProducts" #featuredProducts></app-carousel>
      </div>
    </div>
  </section>
  }
  } @placeholder {
  <section></section>
  }

  <!-- Similar posts -->
  @if (blogPostDetail()?.similarPost?.length) {
  <hr class="mt-4">
  <section>
    <div class="row">
      <div class="col-12">
        <div class="title is-center is-full-width mt-5">
          <h2 class="title__main head-font">Similar Post</h2>
        </div>
      </div>
    </div>
    <div class="row">
      @for (blog of blogPostDetail()?.similarPost; track $index) {
      <div class="col-sm-4 mt-2">
        <app-post [blog]="blog"></app-post>
      </div>
      }
    </div>
  </section>
  }

</div>
} @placeholder (minimum 1s) {
<div class="loading-animation-content">
  <div class="loader">
    @for (item of [0,0,0,0,0]; track $index) {
    <div class="bg-secondary"></div>
    }
  </div>
</div>
}